import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M14.875 13.75H1.125a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h13.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625M7.556.181A.6.6 0 0 1 8 0c.081 0 .163.019.238.05a.6.6 0 0 1 .206.138l4.375 4.375a.622.622 0 1 1-.881.88L8.625 2.132v9.744A.627.627 0 0 1 8 12.5a.627.627 0 0 1-.625-.625V2.131L4.07 5.438a.622.622 0 1 1-.881-.882z"
    }, null, -1)
  ]))]))
}
export default { render: render }